import React, { Component } from "react";
import { observer } from "mobx-react";
import { css } from "react-emotion";

import SVG from "react-inlinesvg";

import theme from "components/theme";

import houzz from "../shapes/social_icons/houzz-m-rgb-la-w.svg";
import facebook from "../shapes/social_icons/facebook-w.svg";
import instagram from "../shapes/social_icons/instagram-w.svg";

class FooterFollowUs extends Component {
  render() {
    const { styles } = this;

    return (
      <div className={styles.root}>
        <div className={styles.elements}>
          <div className={styles.inline}>
            <a
              href="https://www.houzz.de/pro/kitchenadvisor/"
              target="_blank"
              rel="noopener noreferrer"
              alt="https://www.houzz.de/pro/kitchenadvisor/"
              title="https://www.houzz.de/pro/kitchenadvisor/"
            >
              <div className={"icons"}>
                <span>
                  <SVG src={houzz} uniquifyIDs uniqueHash={"ffuh"} />
                </span>
              </div>
            </a>
          </div>
          <div className={styles.inline}>
            <a
              href="https://www.instagram.com/kitchenadvisor/"
              target="_blank"
              rel="noopener noreferrer"
              alt="https://www.instagram.com/kitchenadvisor/"
              title="https://www.instagram.com/kitchenadvisor/"
            >
              <div className={"icons"}>
                <SVG src={instagram} uniquifyIDs uniqueHash={"ffui"} />
              </div>
            </a>
          </div>
          <div className={styles.inline}>
            <a
              href="https://www.facebook.com/kitchenadvisor.de/"
              target="_blank"
              rel="noopener noreferrer"
              alt="https://www.facebook.com/kitchenadvisor.de/"
              title="https://www.facebook.com/kitchenadvisor.de/"
            >
              <div className={"icons"}>
                <SVG src={facebook} uniquifyIDs uniqueHash={"ffuf"} />
              </div>
            </a>
          </div>
        </div>
      </div>
    );
  }

  styles = {
    root: css`
      width: 100%;
      margin-bottom: 64px;
      ${theme.media.xsMax} {
        margin-bottom: 0px;
        padding-bottom: 11.5px;
      }
      text-align: center;
    `,
    elements: css`
      ${theme.media.xsMax} {
        width: 72px;
        height: 72px;
        margin-left: 0px;
        margin-right: auto;
        width: auto;
      }
    `,
    inline: css`
      vertical-align: middle;
      display: inline-block;
      width: 40px;
      height: 40px;
      padding: 12px;
      background-color: ${theme.colors.grayOO};
      border-radius: 50%;
      margin: 0px 5px;
      ${theme.media.xsMax} {
        padding: 12px;
        width: 40px;
        height: 40px;
      }
      &:hover {
        padding: 10px;
        ${theme.media.xsMax} {
          padding: 10px;
        }
        .icons {
          width: 20px;
          height: 20px;
          img,
          svg {
            width: 20px;
            height: 20px;
          }
          ${theme.media.xsMax} {
            width: 16px;
            height: 16px;
            img,
            svg {
              width: 16px;
              height: 16px;
            }
          }
        }
      }
      .icons {
        width: 16px;
        height: 16px;
        img,
        svg {
          width: 16px;
          height: 16px;
        }
        ${theme.media.xsMax} {
          width: 16px;
          height: 16px;
          img,
          svg {
            width: 16px;
            height: 16px;
          }
        }
      }
    `,
  };
}

FooterFollowUs = observer(FooterFollowUs);

export default FooterFollowUs;
